"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionItemComponent = exports.WK_ACCORDION_ITEM_ICON_SIZE = exports.KEYS_TO_LISTEN = exports.ACCORDION_ITEM_I18N_DEFAULTS = exports.ACCORDION_ITEM_I18N_NS = void 0;
var tslib_1 = require("tslib");
var components_utils_1 = require("@wk/components-utils");
var custom_element_1 = require("@wk/custom-element");
exports.ACCORDION_ITEM_I18N_NS = 'wk.accordion.item';
exports.ACCORDION_ITEM_I18N_DEFAULTS = {
    expandLabel: 'Expand',
    collapseLabel: 'Collapse'
};
exports.KEYS_TO_LISTEN = ['Enter', ' '];
exports.WK_ACCORDION_ITEM_ICON_SIZE = 16;
var AccordionItemComponent = (function (_super) {
    tslib_1.__extends(AccordionItemComponent, _super);
    function AccordionItemComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.expanded = false;
        _this.disabled = false;
        _this.i18n = exports.ACCORDION_ITEM_I18N_DEFAULTS;
        _this.headerClickHandler = function () {
            _this.expanded = !_this.expanded;
        };
        _this.headerKeypressHandler = function (e) {
            if (exports.KEYS_TO_LISTEN.indexOf(e.key) !== -1) {
                _this.headerClickHandler();
            }
        };
        return _this;
    }
    AccordionItemComponent.prototype.accordionItemClasses = function () {
        return components_utils_1.generateClasses({
            'wk-accordion-item-element': true,
            'wk-accordion-item-hidden': !this.expanded
        });
    };
    AccordionItemComponent.prototype.accordionHeaderClasses = function () {
        return components_utils_1.generateClasses({
            'wk-accordion-item-header': true,
            'wk-field-is-disabled': this.disabled
        });
    };
    AccordionItemComponent.prototype.hasItemHeaderSlot = function () {
        return !!Array.from(this.children).filter(function (child) { return child.getAttribute('slot') === 'item-header'; }).length;
    };
    AccordionItemComponent.prototype.renderCallback = function () {
        var isItemHeaderSlotNameProvided = this.hasItemHeaderSlot();
        return (custom_element_1.h("div", { className: "wk-accordion-item" },
            custom_element_1.h("div", { className: this.accordionHeaderClasses(), onClick: this.headerClickHandler, onKeyPress: this.headerKeypressHandler, "aria-expanded": String(this.expanded), tabindex: this.disabled ? -1 : 0 },
                custom_element_1.h("slot", { name: "item-header" }),
                !isItemHeaderSlotNameProvided && (custom_element_1.h("div", { className: "wk-accordion-item-header-label" },
                    this.heading,
                    custom_element_1.h("slot", { name: "header" }))),
                custom_element_1.h(components_utils_1.Icon, { size: exports.WK_ACCORDION_ITEM_ICON_SIZE, class: "wk-accordion-icon", name: this.expanded ? 'chevron-up' : 'chevron-down', title: this.expanded
                        ? this.i18n.collapseLabel
                        : this.i18n.expandLabel })),
            custom_element_1.h("div", { className: this.accordionItemClasses() },
                custom_element_1.h("slot", { name: "item" }))));
    };
    tslib_1.__decorate([
        custom_element_1.props.string
    ], AccordionItemComponent.prototype, "heading", void 0);
    tslib_1.__decorate([
        custom_element_1.props.boolean
    ], AccordionItemComponent.prototype, "expanded", void 0);
    tslib_1.__decorate([
        custom_element_1.props.boolean
    ], AccordionItemComponent.prototype, "disabled", void 0);
    tslib_1.__decorate([
        components_utils_1.i18nProperty(exports.ACCORDION_ITEM_I18N_NS, exports.ACCORDION_ITEM_I18N_DEFAULTS),
        custom_element_1.prop()
    ], AccordionItemComponent.prototype, "i18n", void 0);
    AccordionItemComponent = tslib_1.__decorate([
        custom_element_1.element('wk-accordion-item')
    ], AccordionItemComponent);
    return AccordionItemComponent;
}(custom_element_1.CustomElement));
exports.AccordionItemComponent = AccordionItemComponent;
